// extracted by mini-css-extract-plugin
export default {"wrapper":"News_wrapper__fuMlr","newsItems":"News_newsItems__5uFPs"};